var map = {
	"./en-gb.yml": 2293,
	"./jobfeed.de-DE.yml": 4188,
	"./jobfeed.en-GB.yml": 4122,
	"./jobfeed.en-US.yml": 9121,
	"./jobfeed.es-CO.yml": 8052,
	"./jobfeed.es-ES.yml": 1250,
	"./jobfeed.es-MX.yml": 8061,
	"./jobfeed.fr-FR.yml": 3894,
	"./jobfeed.pt-PT.yml": 2770,
	"./jobfeed.sv-SE.yml": 1755
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9728;